import gql from 'graphql-tag';

const GET_CONVERSATIONS_BY_USER_ID = gql`
  query getConversationsByWorkspaceId($userId: ID!, $workspaceId: ID!) {
    getConversationsByWorkspaceId(userId: $userId, workspaceId: $workspaceId) {
      id
      name
      isView
      situationId
      messages {
        id
        type
        body
        senderId
        createdAt
        isView
        metaData
      }
      users {
        id
        firstName
        lastName
        email
        phone
        profilePicture
        userRoles {
          id
          roleId
          role {
            id
            name
          }
        }
        isConnect
        lastUpdateConnect
      }
    }
  }
`;

const CHECK_UNREAD_MESSAGES_BY_USER_ID = gql`
  query getConversationsByWorkspaceId($userId: ID!, $workspaceId: ID!) {
    getConversationsByWorkspaceId(userId: $userId, workspaceId: $workspaceId) {
      isView
      situationId
    }
  }
`;

const GET_MESSAGES_BY_CONVERSATION_ID = gql`
  query MoreMessageByConversationId(
    $conversationId: ID!
    $skip: Int
    $take: Int
  ) {
    moreMessageByConversationId(
      conversationId: $conversationId
      skip: $skip
      take: $take
    ) {
      messages {
        id
        type
        body
        senderId
        createdAt
        metaData
      }
      totalMessages
    }
  }
`;

const SYNC_MESSAGES_BY_CONVERSATION_ID = gql`
  query SyncMessagesByConversationId($conversationId: ID!, $userId: ID!) {
    syncMessagesByConversationId(
      conversationId: $conversationId
      userId: $userId
    ) {
      conversationId
      messages {
        id
        type
        body
        senderId
        createdAt
        isView
      }
    }
  }
`;

const GET_CONVERSATION_BY_ID = gql`
  query GetConversationsById($conversationId: ID!, $userId: ID!) {
    getConversationsById(conversationId: $conversationId, userId: $userId) {
      id
      name
      messages {
        id
        type
        body
        senderId
        createdAt
        isView
        metaData
      }
      users {
        id
        firstName
        lastName
        email
        phone
        profilePicture
        userRoles {
          id
          roleId
          role {
            id
            name
          }
        }
        isConnect
        lastUpdateConnect
      }
      isView
      situationId
    }
  }
`;

const GET_CONVERSATION_DETAILS_BY_ID = gql`
  query GetConversationsById($conversationId: ID!, $userId: ID!) {
    getConversationsById(conversationId: $conversationId, userId: $userId) {
      id
      name
      messages {
        id
        type
        body
        senderId
        createdAt
        isView
        metaData
      }
      users {
        id
        firstName
        lastName
        email
        phone
        profilePicture
        userRoles {
          id
          roleId
          role {
            id
            name
          }
        }
      }
      situationId
    }
  }
`;

export default {
  GET_CONVERSATIONS_BY_USER_ID,
  CHECK_UNREAD_MESSAGES_BY_USER_ID,
  GET_MESSAGES_BY_CONVERSATION_ID,
  GET_CONVERSATION_BY_ID,
  GET_CONVERSATION_DETAILS_BY_ID,
  SYNC_MESSAGES_BY_CONVERSATION_ID,
};
